import { createContext } from 'react';

export const OverlayContext = createContext({
  show: false,
  title: null,
  key: null,
  onBack: null,
  scrollToBottom: false
});
